import { render, staticRenderFns } from "./vendors-pending.vue?vue&type=template&id=71f0bcd2&scoped=true"
import script from "./vendors-pending.vue?vue&type=script&lang=js"
export * from "./vendors-pending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0bcd2",
  null
  
)

export default component.exports